module.exports = __webpack_public_path__ + "static/media/Slide2.986a8335.jpeg";